// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"a408ab69","236":"434e8d91"}[chunkId] + ".css";
};